<div class="flex mt-2 mb-2 px-4 md:px-0 w-full">
  <div class="bg-white/50 backdrop-blur-sm rounded-[10.4px] p-4 shadow-sm border border-white overflow-hidden
           w-full md:inline-block md:w-auto md:max-w-xl">
    <div class="flex items-start gap-3"  [class]="showOptions ? 'flex items-start gap-3 mb-4' : 'flex items-start gap-3 mb-0'">
      <div class="block sm:hidden w-6 h-6 bg-gray-900 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
        <app-ivy-face></app-ivy-face>
      </div>

      <p class="text-sm font-medium text-gray-900">
        {{ data.message }} Please select all that applies.
      </p>
    </div>

    <!-- Symptom Options -->
    @if(showOptions) {
    <div class="space-y-3">
      <div class="flex flex-wrap px-0" [class]="data.answer.options.length < 3
          ? 'justify-center gap-2'
          : 'justify-start gap-4'">
        @for (option of data.answer.options; track option.display) {
        <button (click)="select(option)" [class]="selectedOptions.includes(option) 
              ? 'bg-[#DAD6FB] border-[#DAD6FB]' 
              : 'bg-white border-black/10'"
          class="px-[10px] py-[6px] rounded-full text-[14px] font-medium text-gray-800 border hover:bg-purple-50 transition-colors">
          {{ option.display }}
        </button>
        }
      </div>
    </div>
    }
  </div>
</div>